import { Route } from 'react-router';
import { ForgotPasswordEmailSentPage } from '../ForgotPasswordFlow/ForgotPasswordEmailSentPage/ForgotPasswordEmailSentPage';
import { ForgotPasswordCheckEmailPage } from '../ForgotPasswordFlow/ForgotPasswordCheckEmailPage/ForgotPasswordCheckEmailPage';
import { ForgotPasswordTwoFAPage } from '../ForgotPasswordFlow/ForgotPasswordTwoFAPage/ForgotPasswordTwoFAPage';
import { ForgotPasswordCompleteRegistrationPage } from '../ForgotPasswordFlow/ForgotPasswordCompleteRegistrationPage/ForgotPasswordCompleteRegistrationPage';
import { getForgotPasswordCheckPinCodePath } from '../ForgotPasswordFlow/ForgotPasswordCheckPinCodePage/path/path';
import { ForgotPasswordCheckPinCodePage } from '../ForgotPasswordFlow/ForgotPasswordCheckPinCodePage/ForgotPasswordCheckPinCodePage';
import { AUTH_STEP, FORGOT_PASSWORD_STEP } from '../const/const';
import { AuthProtectedRoute } from '@/bundle/Routes/AuthProtectedRoute';
import { SetPasswordLinkExpiredPage } from '../InviteUserFlow/SetPasswordLinkExpiredPage/SetPasswordLinkExpiredPage';
import { ForgotPasswordSetPasswordPage } from '../ForgotPasswordFlow/ForgotPasswordSetPasswordPage/ForgotPasswordSetPasswordPage';
import { ForgotPasswordValidateTotpPage } from '../ForgotPasswordFlow/ForgotPasswordValidateTotpPage/ForgotPasswordValidateTotpPage';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { getForgotPasswordCheckEmailPath } from '../ForgotPasswordFlow/ForgotPasswordCheckEmailPage/path/path';
import { getForgotPasswordEmailSentPath } from '../ForgotPasswordFlow/ForgotPasswordEmailSentPage/path/path';
import { getForgotPasswordLinkExpiredPath, getForgotPasswordPasswordChangedPath } from '../ForgotPasswordFlow/path';
import { getForgotPasswordTwoFAPath } from '../ForgotPasswordFlow/ForgotPasswordTwoFAPage/path/path';
import { getForgotPasswordValidateTotpPath } from '../ForgotPasswordFlow/ForgotPasswordValidateTotpPage/path/path';
import { getForgotPasswordCompleteRegistrationPath } from '../ForgotPasswordFlow/ForgotPasswordCompleteRegistrationPage/path/path';
import { getForgotPasswordSetPasswordPath } from '../ForgotPasswordFlow/ForgotPasswordSetPasswordPage/path/path';
import { PasswordChangedPage } from '../pages/PasswordChangedPage/PasswordChangedPage';

export const FORGOT_PASSWORD_FLOW_ROUTES = [
  <Route
    key={getForgotPasswordCheckEmailPath()}
    path={getForgotPasswordCheckEmailPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.PASSWORD_AUTHENTICATION}>
        <ForgotPasswordCheckEmailPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getForgotPasswordValidateTotpPath()}
    path={getForgotPasswordValidateTotpPath()}
    element={<ForgotPasswordValidateTotpPage />}
  />,
  <Route
    key={getForgotPasswordTwoFAPath()}
    path={getForgotPasswordTwoFAPath()}
    element={
      <AuthProtectedRoute allowedStep={FORGOT_PASSWORD_STEP.TWO_FACTOR_AUTHENTICATION}>
        <ForgotPasswordTwoFAPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getForgotPasswordCompleteRegistrationPath()}
    path={getForgotPasswordCompleteRegistrationPath()}
    element={
      <AuthProtectedRoute allowedStep={FORGOT_PASSWORD_STEP.COMPLETE_REGISTRATION}>
        <ForgotPasswordCompleteRegistrationPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getForgotPasswordCheckPinCodePath()}
    path={getForgotPasswordCheckPinCodePath()}
    element={
      <AuthProtectedRoute allowedStep={FORGOT_PASSWORD_STEP.PIN_AUTHENTICATION}>
        <ForgotPasswordCheckPinCodePage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getForgotPasswordSetPasswordPath()}
    path={getForgotPasswordSetPasswordPath()}
    element={
      <AuthProtectedRoute allowedStep={FORGOT_PASSWORD_STEP.SET_PASSWORD}>
        <ForgotPasswordSetPasswordPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getForgotPasswordEmailSentPath()}
    path={getForgotPasswordEmailSentPath()}
    element={<ForgotPasswordEmailSentPage />}
  />,
  <Route
    key={getForgotPasswordLinkExpiredPath()}
    path={getForgotPasswordLinkExpiredPath()}
    element={
      <SetPasswordLinkExpiredPage
        onRedirect={() => amplitudeService.logEvent(AMPLITUDE_EVENTS.ForgotPasswordLinkExpired)}
      />
    }
  />,
  <Route
    key={getForgotPasswordPasswordChangedPath()}
    path={getForgotPasswordPasswordChangedPath()}
    element={
      <PasswordChangedPage
        onRedirect={() => amplitudeService.logEvent(AMPLITUDE_EVENTS.ForgotPasswordSetPasswordSuccessLoginRedirect)}
      />
    }
  />,
];
